import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconExpand = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.25 1.875L13.125 9.75V1.875H5.25Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.875 13.125H9.75L1.875 5.25V13.125Z",
		fill: "currentColor"
	})]
});
export default SvgIconExpand;
